<template>
    <div class="sm:col-span-12">
        <FormLabel :value="$tc('messages.answers', 2)" />
        <template v-if="form.answers">
            <div class="sm:col-span-12" v-for="(answer, index) in form.answers" :key="`${index}_${answer}`">
                <div class="mt-1">
                    <FormLabel :value="$t('messages.option_X', { x: index + 1 })" :for="`option_${index}`">
                        <CorrectIncorrectIcon :is-correct="true" />
                    </FormLabel>
                    <div class="flex justify-between items-center">
                        <FormInput
                            required
                            :id="`option_${index}`"
                            v-model="answer.latex"
                            :name="`option_${index}`"
                            type="text"
                            max="191"
                            class="mt-1 w-full"
                        />
                        <button
                            type="button"
                            @click="deleteOption(form.answers, index)"
                            v-if="index > 0"
                            class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded text-gray-700 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        >
                            <svg viewBox="0 0 20 20" fill="currentColor" class="trash w-4 h-4">
                                <path
                                    fill-rule="evenodd"
                                    d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                        </button>
                    </div>
                    <div>
                        <LatexDisplay :model-value="answer.latex" />
                    </div>
                    <FormError :value="errors[`options.answers.${index}.text`]" class="mt-2" />
                </div>
            </div>

            <div v-show="form.answers.length < 8" class="mt-1">
                <PlusButton @click="addOption()" />
            </div>
        </template>
    </div>
</template>

<script>
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormError from '@/components/Forms/FormError.vue';
import PlusButton from '@/components/Forms/PlusButton.vue';
import CorrectIncorrectIcon from '@/components/Quiz/CorrectIncorrectIcon.vue';
import LatexDisplay from '../LatexDisplay.vue';

export default {
    name: 'QuestionMathLatexAnswerOptions',
    components: {
        LatexDisplay,
        FormLabel,
        FormInput,
        FormError,
        PlusButton,
        CorrectIncorrectIcon,
    },
    props: {
        modelValue: {
            required: true,
        },
        errors: {
            required: true,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            form: this.modelValue,
        };
    },
    watch: {
        form(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },
    methods: {
        deleteOption(answers, index) {
            answers.splice(index, 1);
        },
        addOption() {
            this.form.answers.push({ text: '' });
        },
    },
    mounted() {
        let defaultOptions = {
            answers: [{ latex: '' }],
        };
        if (!this.form.hasOwnProperty('answers')) {
            Object.entries(defaultOptions).forEach((entry) => (this.form[entry[0]] = entry[1]));
        }
    },
};
</script>
